export { default } from './CGMOrdersFragment';
